import { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { httpRequest } from '@calendly/http-tools'

export const useInvoiceQuery = () => {
  const { invoiceUuid } = useParams()
  const [loading, setLoading] = useState(true)
  const [invoice, setInvoice] = useState(null)
  const [error, setError] = useState(null)

  const refetch = useCallback(async () => {
    if (!invoiceUuid) return

    setError(null)

    try {
      const [ok, response] = await httpRequest({
        url: `/api/booking/invoices/${invoiceUuid}`,
        method: 'GET',
      })

      if (ok && response?.resource) {
        setInvoice(response.resource)
      } else {
        setError(response ?? new Error('Request failed'))
        setInvoice(null)
      }
    } catch (err) {
      setError(err)
      setInvoice(null)
    }
  }, [invoiceUuid])

  useEffect(() => {
    const fetchInvoice = async () => {
      if (!invoiceUuid) {
        setLoading(false)
        return
      }

      setError(null)

      try {
        const [ok, response] = await httpRequest({
          url: `/api/booking/invoices/${invoiceUuid}`,
          method: 'GET',
        })

        if (ok && response?.resource) {
          setInvoice(response.resource)
        } else {
          setError(response ?? new Error('Request failed'))
          setInvoice(null)
        }
      } catch (err) {
        setError(err)
        setInvoice(null)
      } finally {
        setLoading(false)
      }
    }

    fetchInvoice()
  }, [invoiceUuid])

  return { loading, invoice, error, setInvoice, refetch }
}
